import { RoleName } from '~/types/api/user/role'
import { API } from '~/utils/api'

// Simple object to store roles that pages can set before middleware runs
export const accessConfig = {
  requiredRoles: [] as RoleName[]
}

// Function to set the roles that will be checked
export function setRequiredRoles(roles: RoleName[]) {
  accessConfig.requiredRoles = roles
}

export default defineNuxtRouteMiddleware(async (to) => {
  const pnapi = new API()
  // Get required roles from page meta if defined
  const pageRoles = to.meta.accessFor as RoleName[] | undefined
  accessConfig.requiredRoles = pageRoles || []

  if (accessConfig.requiredRoles?.length > 0) {
    try {
      const hasAccess = await pnapi.user().checkAccess(accessConfig.requiredRoles)
      to.meta.hasAccess = hasAccess
    } catch (error) {
      console.error('Error checking access in middleware:', error)
      to.meta.hasAccess = false
    }
  } else {
    to.meta.hasAccess = undefined
  }

  // User ID is synced into Pinia from the layout (middleware runs before Pinia is available on SSR).
}) 